/**
 * The password rule, as the portal states it.
 *
 * A COPY of the app server's `src/auth/passwordPolicy.ts`, which is where the
 * rule is actually enforced — these two builds share no code. This one exists so
 * a vet is told the rule while they type instead of discovering it from a
 * rejected submit; if they get past it anyway, the server still says no. Change
 * the rule there and change it here (and in mobile/src/screens/AuthScreen.tsx).
 */

export const PASSWORD_MIN_LENGTH = 12;

/** For placeholders and helper text under the field. */
export const PASSWORD_RULE_TEXT =
  `At least ${PASSWORD_MIN_LENGTH} characters, including a number and a symbol`;

/** For the rejection. States all three clauses, not just the one they missed. */
export const PASSWORD_POLICY_MESSAGE =
  `Your password needs at least ${PASSWORD_MIN_LENGTH} characters, including a number and a symbol.`;

/** A symbol is anything that is neither a letter nor a digit — see the server copy. */
export function meetsPasswordPolicy(password: string): boolean {
  return password.length >= PASSWORD_MIN_LENGTH
    && /[0-9]/.test(password)
    && /[^A-Za-z0-9]/.test(password);
}
